import SearchKeywordGrid from './searchKeywordGrid'
export default SearchKeywordGrid
